<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="alterar-valor__title">Valor Financiado</h4>
  </div>

  <div class="modal-body alterar-valor__body">
    <form [formGroup]="alterarValorForm" class="forms">
      <div class="inputs">
        <input
          #valorFinanciamentoInput
          class="form-control alterar-valor__body_input"
          type="text"
          placeholder="R$ 00.000,00"
          [maxLength]="15"
          [minLength]="1"
          appShowErrorMessages
          appOnlyDigitsLengthValidator
          formControlName="valorFinanciamento"
          name="valorFinanciamento"
          mask-money
          [prefix]="'R$'"
          appOnlyMoney>
      </div>
    </form>
  </div>
  <div class="alterar-valor__body_warning" [ngClass]="{'alterar-valor__body_warning_color': !alterarValorForm.valid}">
    Digite um valor entre {{ valorMinimo | currency:'BRL':'symbol':'1.2-2' }} e {{ valorMaximo | currency:'BRL':'symbol':'1.2-2' }}
  </div>

  <div class="modal-footer alterar-valor__footer">
    <button
      type="button"
      class="btn btn-full-orange "
      [disabled]="!alterarValorForm.valid"
      (click)="save()">
      Confirmar valor
    </button>
  </div>
</div>
